(function(APP, $, window, document) {

	function ArchiveFormation(options) {
		if (!(this instanceof ArchiveFormation)) return new ArchiveFormation(options);

		$hero_title_softwares = $('.js-hero-title-softwares');

		Vue.component('v-select', VueSelect.VueSelect);
    Vue.component('paginate', VuejsPaginate)

		var $section_listing = $('.section--listing');

    new Vue({
		  el: '.js-vue',
		  data: function() {
				return {
					search: {
						term: '',
						categorie: null,
					  theme: null,
					  logiciel: null,
					  eligible_cpf: false,
					  prestation: [],
					  dates: null,
					  centres: [],
					},
					is_loading: true,
					formations: [],
					formations_filter: [],
					formations_filter_after_date: [],
					formations_render: [],
					formations_max_per_page: 20,
					is_formations_filter_out_of_range: false,
					pagination: 1,
					pagination_page_count: 0,
					term_duration_change: null,
					term_ajax_function: null,
					categorie_props: {
						options: [],
						placeholder: 'Choisir une catégorie',
						searchable: false,
					},
					theme_props: {
						options_all: [],
						options: [],
						placeholder: 'Choisir un thème',
						searchable: false,
						disabled: false,
					},
					logiciel_props: {
						options_all: [],
						options: [],
						placeholder: 'Choisir un logiciel',
						searchable: false,
						disabled: false,
					},
	        filters_list: [],
	        input_term: '',
	        input_categorie: null,
	        input_theme: null,
	        input_logiciel: null,
					input_prestation: [],
					input_eligible_cpf: false,
					input_dates: null,
					input_centres: [],
			  }
		  },
			created: function () {

				this.is_loading = true;

				// Au chargement de la page, on commence par bien paramétré la variable "search" avec la recherche renseigné dans l'url
				// Elle met du coup la variable "search" à jour
				this.getURLSearch();

				// On fait correspondre les champs avec la recherche de l'url
				this.input_term = this.search.term;
				this.input_categorie = this.search.categorie;
				this.input_theme = this.search.theme;
				this.input_logiciel = this.search.logiciel;
				this.input_prestation = this.search.prestation;
				this.input_eligible_cpf = this.search.eligible_cpf;
				this.input_dates = this.search.dates;
				this.input_centres = this.search.centres;

				// On ajoute les "option" dans les champs "categorie", "theme" et "logiciel"
				for (var i = 0; i < catalog_types.length; i++) {
					this.categorie_props.options.push({
						value: catalog_types[i].id,
						label: catalog_types[i].label,
					});
				}

				this.theme_props.options_all = this.theme_props.options_all.concat(themes);
				this.logiciel_props.options_all = this.logiciel_props.options_all.concat(logiciel);

				// On met à jour le champ "categorie" pour lui inséré l'option qui lui est renseigné
				this.updateSelectValue('categorie');

				// On met à jour les options du champ "theme" selon ce qui est renseigné dans "categorie"
				this.updateSelectOptions('theme');
				// On met à jour le champ "theme" pour lui inséré l'option qui lui est renseigné
				this.updateSelectValue('theme');

				// On met à jour les options du champ "logiciel" selon ce qui est renseigné dans "theme"
				this.updateSelectOptions('logiciel');
				// On met à jour le champ "logiciel" pour lui inséré l'option qui lui est renseigné
				this.updateSelectValue('logiciel');

				// On boucle sur les formations pour changer le type des variables de dates
				formations = this.parseFormationsForChangeSessionsDateType(formations);

				// On inject les formations
				this.formations = formations;
				this.formations_filter = formations;
				this.formations_render = this.getFormations(this.formations_filter, this.formations_max_per_page, 0);

				this.pagination_page_count = Math.ceil(this.formations.length / this.formations_max_per_page);

				// Si il y a un mot clé de renseigné d'abord on fait la cherche (et il lancera les filtres)
				// Soit on filtre directement avec les formations actuelles
				if (this.input_term) {
					this.updateTerm();
				} else {
					this.updateFilters();
				}
			},
			methods: {
        getDateFormat: function (date) {
					if (typeof date !== 'object') {
						return false;
					}

					var dd = date.getDate();
					var mm = date.getMonth() + 1;

					var yyyy = date.getFullYear();

					if (dd < 10){
						dd = '0' + dd;
					}

					if (mm < 10){
						mm = '0' + mm;
					}

					return yyyy + '-' + mm + '-' + dd;
        },
        toggleFilters: function (event) {
          APP.$html.toggleClass('filters-is-open');
        },
				getURLSearch: function() {

					var filters = window.location.hash.replace('#', '').split('|');

					for (var key = 0; key < filters.length; key++) {

						// Term
						if (filters[key].indexOf('term') > -1) {
							var value = filters[key].split(':');
							this.search.term = (value.length > 1) ? decodeURIComponent(value[1]) : '';
						}

						// Categorie
						if (filters[key].indexOf('categorie') > -1) {
							var value = filters[key].split(':');
							this.search.categorie = (value.length > 1) ? {value: parseInt(value[1]), label: ''} : null;
						}

						// Theme
						if (filters[key].indexOf('theme') > -1) {
							var value = filters[key].split(':');
							this.search.theme = (value.length > 1) ? {value: parseInt(value[1]), label: ''} : null;
						}

						// Logiciel
						if (filters[key].indexOf('logiciel') > -1) {
							var value = filters[key].split(':');
							this.search.logiciel = (value.length > 1) ? {value: parseInt(value[1]), label: ''} : null;
						}

						// Eligible CPF
						if (filters[key] === 'eligible_cpf') {
							this.search.eligible_cpf = true;
						}

						// Prestation
						if (filters[key].indexOf('prestation') > -1) {
							var value = filters[key].split(':');
							this.search.prestation = (value.length > 1 && value[1] !== '') ? value[1].split(';') : [];
						}

						// Dates
						if (filters[key].indexOf('dates') > -1) {
							var value = filters[key].split(':');
							if (value.length > 1) {
								value = value[1].split(';');
								this.search.dates = {
									start: new Date(value[0]),
									end: new Date(value[1]),
								}
							}
						}

						// Centres
						if (filters[key].indexOf('centres') > -1) {
							var value = filters[key].split(':');
							this.search.centres = (value.length > 1 && value[1] !== '') ? value[1].split(';') : [];
						}
					}
				},
				handleChangeTerm: function () {

					this.is_loading = true;

					if (this.term_ajax_function) {
						this.term_ajax_function.abort();
					}

					if (this.term_duration_change) {
						clearTimeout(this.term_duration_change);
					}

					this.term_duration_change = setTimeout(function() {
						this.updateTerm();
					}.bind(this), 250);
				},
				handleChangeCategorie: function () {

					// On met à jour les options du champ "theme" selon ce qui est renseigné dans "categorie"
					this.updateSelectOptions('theme');
					// On met à jour le champ "theme" pour lui inséré l'option qui lui est renseigné
					this.updateSelectValue('theme');

					// On met à jour les options du champ "logiciel" selon ce qui est renseigné dans "theme"
					this.updateSelectOptions('logiciel');
					// On met à jour le champ "logiciel" pour lui inséré l'option qui lui est renseigné
					this.updateSelectValue('logiciel');

					// On filtre directement avec les formations actuelles
					this.updateFilters();
				},
				handleChangeTheme: function () {

					// On met à jour les options du champ "logiciel" selon ce qui est renseigné dans "theme"
					this.updateSelectOptions('logiciel');
					// On met à jour le champ "logiciel" pour lui inséré l'option qui lui est renseigné
					this.updateSelectValue('logiciel');

					// On filtre directement avec les formations actuelles
					this.updateFilters();
				},
				handleChangeLogiciel: function () {

					// Si il y a un logiciel de renseigné et qu'on est dans "Toutes les formations", alors on ajoute le nom du logiciel
					if (this.input_logiciel && this.input_logiciel.label) {
						$hero_title_softwares.text(' ' + this.input_logiciel.label);
					} else {
						$hero_title_softwares.text('');
					}

					// On filtre directement avec les formations actuelles
					this.updateFilters();
				},
				updateTerm: function () {
					this.term_ajax_function = $.ajax({
						url: '/wp-admin/admin-ajax.php',
						method: 'post',
						dataType: 'json',
						data: {
							action: 'ajax_archive_formation_formation_by_term',
							term: encodeURIComponent(this.input_term),
						},
						success: function(data) {
							if (data.error) {
								return false;
							}

							data.formations = this.parseFormationsForChangeSessionsDateType(data.formations);
							this.formations = data.formations;

						}.bind(this),
						complete: function() {
							this.updateFilters();
						}.bind(this),
					});
				},
				updateSelectOptions: function (select_type) {
					if (typeof select_type !== 'string') {
						return false;
					}

					// Thèmes
					if (select_type === 'theme') {

						this.theme_props.options = [];

						for (var i = 0; i < this.theme_props.options_all.length; i++) {
							if (!this.input_categorie || (this.input_categorie && this.input_categorie.value === '') || (this.input_categorie && this.input_categorie.value === this.theme_props.options_all[i].catalog_type) || this.theme_props.options_all[i].value === '') {

								this.theme_props.options.push({
									value: this.theme_props.options_all[i].field_id,
									label: this.theme_props.options_all[i].label,
								});
							}
						}

						this.theme_props.disabled = (this.theme_props.options.length) ? false : true;
					}

					// Logiciels
					if (select_type === 'logiciel') {

						this.logiciel_props.options = [];

						for (var i = 0; i < this.logiciel_props.options_all.length; i++) {

							// Si il n'y a pas d'options pour le champ select "theme_input"
							// Alors on n'ajoute aucune options pour le champs select "logiciel_input"
							if (!this.theme_props.options.length) {
								continue;
							}

							if (!this.input_theme || (this.input_theme && this.input_theme.value === '') || (this.input_theme && this.input_theme.value === this.logiciel_props.options_all[i].field) || this.logiciel_props.options_all[i].value === '') {

								if (!this.input_categorie || (this.input_categorie && this.input_categorie.value === '') || (this.input_categorie && this.input_categorie.value === this.logiciel_props.options_all[i].catalogtype_id) || this.logiciel_props.options_all[i].value === '') {

									this.logiciel_props.options.push({
										value: this.logiciel_props.options_all[i].id,
										label: this.logiciel_props.options_all[i].label,
									});
								}
							}
						}

						this.logiciel_props.disabled = (this.logiciel_props.options.length) ? false : true;
					}
				},
				updateSelectValue: function (select_type) {
					if (typeof select_type !== 'string') {
						return false;
					}

					// Catégorie
					if (select_type === 'categorie') {

						var options_matches = this.categorie_props.options.filter(function(option) {
							return (this.input_categorie && option.value === this.input_categorie.value) ? true : false;
						}.bind(this));
						this.input_categorie = (options_matches.length) ? options_matches[0] : null;
					}

					// Thèmes
					if (select_type === 'theme') {

						var options_matches = this.theme_props.options.filter(function(option) {
							return (this.input_theme && option.value === this.input_theme.value) ? true : false;
						}.bind(this));
						this.input_theme = (options_matches.length) ? options_matches[0] : null;
					}

					// Logiciel
					if (select_type === 'logiciel') {

						var options_matches = this.logiciel_props.options.filter(function(option) {
							return (this.input_logiciel && option.value === this.input_logiciel.value) ? true : false;
						}.bind(this));
						this.input_logiciel = (options_matches.length) ? options_matches[0] : null;
					}
				},
				updateFilters: function (date_range) {
					this.is_loading = false;
					this.is_formations_filter_out_of_range = false;

					/*
					 * Le système de filtres marche comme ça :
					 * On récupère la liste des filtres qui on était modifiés dans un tableau
					 * En suite on passe sur toutes les formations pour vérifier si ils "match" bien avec les filtres
					 */

					this.filters_list = [];

					if (this.input_categorie && typeof this.input_categorie.value === 'number') {
						this.filters_list.push('input_categorie');
					}

					if (this.input_theme && typeof this.input_theme.value === 'number') {
						this.filters_list.push('input_theme');
					}

					if (this.input_logiciel && typeof this.input_logiciel.value === 'number') {
						this.filters_list.push('input_logiciel');
					}

					if (this.input_eligible_cpf) {
						this.filters_list.push('input_eligible_cpf');
					}

					if (this.input_prestation.length) {
						this.filters_list.push('input_prestation');
					}

					if (this.input_centres.length) {
						this.filters_list.push('input_centres');
					}

					/*
					 * On passe dans les formations et on retourne celle qui on la variable "show" à 1 uniquement
					 * La variable show correspond au pourcentage de "match" avec les filtres renseigné, et on retourne uniquement ceux avec un "match" à 100% (donc la valeur : 1)
					 */

					this.formations_filter = this.formations.filter(this.formations_filter_function);

					var formations_in_range = [];

					if (this.input_dates && this.formations_filter.length) {

						formations_in_range = this.formations_filter.filter(function(formation) {
							var is_in_range = false;
							if (formation.sessions.length) {

								for (var i = 0; i < formation.sessions.length; i++) {

									if (formation.sessions[i].date.start >= this.input_dates.start && formation.sessions[i].date.start <= this.input_dates.end ||
										formation.sessions[i].date.end <= this.input_dates.end && formation.sessions[i].date.end >= this.input_dates.start) {
										is_in_range = true;
									}
								}
							}
							return is_in_range;
						}.bind(this));

						this.formations_filter = formations_in_range;
					}

					if (this.input_dates && !this.formations_filter.length) {

						this.is_formations_filter_out_of_range = true;

						var formations_out_range = this.formations.filter(function(formation) {
							var is_in_range = false;
							if (!formation.sessions.length) {
								return false;
							}

							for (var i = 0; i < formation.sessions.length; i++) {

								if (formation.sessions[i].date.start >= this.input_dates.start && formation.sessions[i].date.start <= this.input_dates.end ||
									formation.sessions[i].date.end <= this.input_dates.end && formation.sessions[i].date.end >= this.input_dates.start) {
									is_in_range = true;
								}
							}

							return !is_in_range;
						}.bind(this));

						this.formations_filter = formations_out_range;
					}

					// On affiche la première page de formations
					this.formations_render = this.getFormations(this.formations_filter, this.formations_max_per_page, 0);

					// On passe la pagination de-nouveau à 1
					Vue.set(this, 'pagination', 1);

					// On re-calcule le nombre de pagination qu'il faut avec les filtres choisis
					this.pagination_page_count = Math.ceil(this.formations_filter.length / this.formations_max_per_page);

					// On ajoute la recherche dans la barre de recherche, mais sans l'ajouter à l'historique du navigateur
					window.history.replaceState(undefined, undefined, '#'+this.createSearchSlug());
				},
				formations_filter_function: function(formation) {
					var show = 0;
					var show_range = 1 / this.filters_list.length;

					if (this.input_categorie && this.input_categorie.value == formation.CatalogType.catalog_type_id) {
						show = show + show_range;
					}

					if (this.input_theme && this.input_theme.value == formation.Field.field_id) {
						show = show + show_range;
					}

					if (this.input_logiciel && this.input_logiciel.value == formation.software) {
						show = show + show_range;
					}

					if (this.input_eligible_cpf && formation.cpfEligibility === 'YES') {
						show = show + show_range;
					}

					if (this.input_prestation.length && this.input_prestation.indexOf(formation.training_delivery) > -1) {
						show = show + show_range;
					}

					if (this.input_centres.length && formation.sessions.length) {

						var in_center = false;

						for (var i = 0; i < formation.sessions.length; i++) {

							if (this.input_centres.indexOf(''+formation.sessions[i].center) > -1 && !in_center) {
								show = show + show_range;
								in_center = true;
							}
						}
					}

					return (show === 1 && this.filters_list.length || this.filters_list.length === 0) ? true : false;
				},
        resetDate: function (event) {
					this.input_dates = null;

					this.updateFilters();
        },
        resetFilters: function (event) {
					this.filters_list = [];
					this.input_term = '';
					this.input_categorie = null;
					this.input_theme = null;
					this.input_logiciel = null;
					this.input_prestation = '';
					this.input_eligible_cpf = false;
					this.input_dates = null;
					this.input_centres = [];

					this.updateFilters();
        },
        clickPagination: function(page_number) {
					// On affiche les formations de la pagination sélectionné
          this.formations_render = this.getFormations(this.formations_filter, 20, page_number - 1);

					TweenLite.to(APP.$html, 0.75, {
						scrollTop: ($section_listing.length) ? $section_listing[0].getBoundingClientRect().top + document.documentElement.scrollTop : 0,
					});
        },
				getFormations: function(formations, count, offset) {
					// On retourne les formations compris entres "count" et "offset"
          return formations.slice(count * offset, count * offset + count);
        },
				createSearchSlug: function() {

					var search = [];

					if (this.input_term) {
						search.push('term:' + encodeURIComponent(this.input_term));
					}
					if (this.input_categorie && typeof this.input_categorie.value === 'number') {
						search.push('categorie:' + this.input_categorie.value);
					}
					if (this.input_theme && typeof this.input_theme.value === 'number') {
						search.push('theme:' + this.input_theme.value);
					}
					if (this.input_logiciel && typeof this.input_logiciel.value === 'number') {
						search.push('logiciel:' + this.input_logiciel.value);
					}
					if (this.input_eligible_cpf) {
						search.push('eligible_cpf');
					}
					if (this.input_prestation.length) {
						search.push('prestation:' + this.input_prestation.join(';'));
					}
					if (this.input_dates && this.input_dates.start && this.input_dates.end) {
						search.push('dates:' + this.getDateFormat(this.input_dates.start) + ';' + this.getDateFormat(this.input_dates.end));
					}
					if (this.input_centres.length) {
						search.push('centres:' + this.input_centres.join(';'));
					}

          return search.join('|');
        },
				parseFormationsForChangeSessionsDateType: function(formations) {

					for (var i = 0; i < formations.length; i++) {

						if (!formations[i].sessions.length) {
							continue;
						}

						for (var i_session = 0; i_session < formations[i].sessions.length; i_session++) {

							formations[i].sessions[i_session].date.start = new Date(formations[i].sessions[i_session].date.start);
							formations[i].sessions[i_session].date.end = new Date(formations[i].sessions[i_session].date.end);
						}
					}

					return formations;
				},
			},
		});

		return this;
	}

	$(window).on('load', function() {
		APP.store.archiveFormation = new ArchiveFormation();
	});

})(APP, jQuery, window, document);
